import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setOrdered } from "store/checkout/order/orderSlice";
import {
    getTableLaterOrders
  } from "apiHelpers/api/ApiHelpers";
import { useCustomHistory } from "hooks";
import { setIsSplitted } from 'store/checkout/cart/cartSlice';
import { setSplitedItems } from 'store/checkout/order/orderSlice';
import { clearSplit } from 'store/checkout/cart/cartSlice';

function mergeItemsByOrderAndItemId(items) {
  const map = new Map();

  for (const item of items) {
      const key = `${item.orderId}-${item.itemId}`;
      if (map.has(key)) {
          const existing = map.get(key);
          existing.selectedQunatity += item.selectedQunatity;
      } else {
          map.set(key, { ...item });
      }
  }

  return Array.from(map.values());
}

const usePayLaterOrders = (brandInfo) => {
  const { DomainType } = useSelector((state) => state.AppReducer);
  const dispatch = useDispatch();
  const location = useLocation();
  const router = useCustomHistory();
  const [error, setError] = useState(null);
  const brandId = brandInfo?.brand?._id;

  const queryParams = new URLSearchParams(location.search);
  const tableNumber = queryParams.get('table-number');
  const storeId = queryParams.get('store-id');

  useEffect(() => {
    if (location.pathname.includes('/dine-in') && brandId && tableNumber) {
      const fetchPayLaterOrders = async () => {
        try {
          const response = getTableLaterOrders({ brandId, tableNumber, storeId });
          const result = await response;
          const fetchedOrders = result?.data?.fetchedOrder ?? [];
          const splitBills = result?.data?.splitBills ?? [];
          const splitPayed = parseFloat(
            splitBills.reduce((total, bill) =>  total + (bill.totalAmount || 0), 0).toFixed(2)
          );
          if(splitBills?.length > 0){
            let splitedItems = []
            splitBills?.forEach(bill => {
              splitedItems.push(...bill?.selectedItems)
            })
            splitedItems = mergeItemsByOrderAndItemId(splitedItems)
            dispatch(setSplitedItems(splitedItems))
          }else{
            dispatch(setSplitedItems([]))
            dispatch(setIsSplitted(false))
          }
          const ordersTotalPrice = fetchedOrders ? parseFloat((fetchedOrders.reduce((total, order) => total + (order?.totalOrderPrice || 0), 0)).toFixed(2)) : 0;
          if (fetchedOrders) {
            dispatch(setOrdered({
              splitBills,
              splitPayed,
              orderesTotalItemsPrice:parseFloat((fetchedOrders.reduce((total, order) => total + (order?.itemsTotalPrice || 0), 0)).toFixed(2)),
              ordersTotalPrice,
              ordersTotalTax: parseFloat((fetchedOrders.reduce((total, order) => {
                const itemsTotalPrice = order?.itemsTotalPrice || 0;
                const taxRate = order?.taxRate || 0;
                const taxAmount = (itemsTotalPrice * taxRate) / 100;
                return total + (isNaN(taxAmount) ? 0 : taxAmount);
              }, 0)).toFixed(2)),
              totalTipAmount: parseFloat((fetchedOrders.reduce((total, order) => total + order.tipAmount , 0)).toFixed(2)),
              allOrders: fetchedOrders.map((fo) => ({
                selectedPaymentMethod: fo.selectedPaymentMethod,
                ...(fo.selectedTip && {
                  selectedTip:fo.selectedTip
                } ),
                paymentType: fo.paymentType,
                discountApplied: fo.discountApplied,
                itemsTotalPrice: fo.itemsTotalPrice,
                orderCurrency: fo.orderCurrency,
                orderedMenu: fo.orderedMenu,
                orderNumber: fo.orderNumber,
                orderPlacedTime: fo.orderPlacedTime,
                totalOrderPrice: fo.totalOrderPrice,
                taxRate: fo.taxRate,
                _id: fo._id,
              })),
            }));
            if (fetchedOrders.length > 0) {
              dispatch(setIsSplitted(splitBills?.length > 0 || false));
              PayLaterTab();
            }else setIsSplitted(false)
          } else {
            dispatch(setOrdered({}));
            setIsSplitted(false)
            dispatch(setSplitedItems([]))
            dispatch(clearSplit())
          }
        } catch (err) {
          setError(err);
          setIsSplitted(false)
        }
      };

      fetchPayLaterOrders();
    }
  }, [brandId, tableNumber, storeId]);

  const PayLaterTab = () => {
    if (brandInfo?.setting?.temporaryDomainName) {
      router(
        `/dine-in/paylater`,
        `/${brandInfo.setting.temporaryDomainName}/dine-in/paylater`,
        DomainType,
        null,
        `?${queryParams}`
      );
    }
  };

  return { error };
};

export default usePayLaterOrders;
